(function () {
  var el = document.getElementById('lenz-paylater-data');
  if (!el || el.dataset.hasTag !== 'true') return;

  var installments = parseInt(el.dataset.installments, 10) || 4;
  var label = el.dataset.label || 'PayLater';
  var learnMore = el.dataset.learnMore || '';
  var logoUrl = el.dataset.logo || '';
  var logoWidth = parseInt(el.dataset.logoWidth, 10) || 60;
  var wrap = null;

  function parsePrice() {
    var priceEl =
      document.querySelector('.main__price .price-item--regular') ||
      document.querySelector('.main__price .price-item--sale') ||
      document.querySelector('.price--large .price-item--regular') ||
      document.querySelector('.price--large .price-item--sale') ||
      document.querySelector('.price--large .price-item--last') ||
      document.querySelector('.price__regular .price-item--regular');
    if (!priceEl) return null;
    var text = priceEl.textContent.replace(/[^\d.,]/g, '').replace(',', '');
    var val = parseFloat(text);
    return isNaN(val) ? null : val;
  }

  function formatAmount(val) {
    return val.toLocaleString('en-QA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function buildWidget(price) {
    var monthly = price / installments;
    var learnMoreHtml = '';

    var div = document.createElement('div');
    div.className = 'lenz-paylater-wrap';
    div.id = 'lenz-paylater-wrap';
    var iconHtml = logoUrl
      ? '<div class="lenz-paylater-icon"><img src="' + logoUrl + '" alt="' + label + '" style="width:' + logoWidth + 'px;height:auto;display:block;"></div>'
      : '<div class="lenz-paylater-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 4C5.9 4 5 4.9 5 6v12c0 1.1.9 2 2 2h3v-2H7V6h5c1.66 0 3 1.34 3 3s-1.34 3-3 3H9v2h3c2.76 0 5-2.24 5-5S14.76 4 12 4H7z"/></svg></div>';

    div.innerHTML =
      iconHtml +
      '<div class="lenz-paylater-text">' +
        '<p class="lenz-paylater-headline">Split your payment into ' + installments + ' interest-free installments</p>' +
        '<p class="lenz-paylater-sub">Pay <strong>QAR ' + formatAmount(monthly) + '/month</strong> with ' + label + learnMoreHtml + '</p>' +
      '</div>';
    return div;
  }

  function updateAmount(price) {
    if (!wrap) return;
    var monthly = price / installments;
    var sub = wrap.querySelector('.lenz-paylater-sub');
    if (!sub) return;
    var strong = sub.querySelector('strong');
    if (strong) strong.textContent = 'QAR ' + formatAmount(monthly) + '/month';
  }

  function inject() {
    if (document.getElementById('lenz-paylater-wrap')) return;

    var price = parsePrice();
    if (!price) return;

    wrap = buildWidget(price);

    // Insert AFTER the product form (below the entire grey box)
    var formBox =
      document.querySelector('.product-form') ||
      document.querySelector('[action*="/cart/add"]');

    if (formBox) {
      formBox.parentNode.insertBefore(wrap, formBox.nextSibling);
    }
  }

  // Listen for variant changes (Dawn / OS2.0 themes dispatch this)
  document.addEventListener('variant:changed', function (e) {
    if (!e.detail || !e.detail.variant) return;
    var price = e.detail.variant.price / 100;
    if (wrap) {
      updateAmount(price);
    } else {
      inject();
    }
  });

  // Also listen to the native Shopify variant change event
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest('variant-selects, variant-radios, .product-form')) return;
    setTimeout(function () {
      var price = parsePrice();
      if (!price) return;
      if (wrap) updateAmount(price);
      else inject();
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
